// Regra única do preço das etapas de um item (achado 251, 04/10/2026).
//
// O cadastro do produto oferece três tipos de cálculo por etapa: Soma, Máximo e
// Subtração. Cada janela de venda fazia a conta por conta própria e só entendia
// "soma" e "maior": etapa gravada como "maximo" ou "subtracao" saía de graça.
// Agora todas chamam estas funções. A mesma regra existe no servidor em
// backend/services/item_pedido/etapas.py (a CLEO e a conferência do pedido usam).

export const TIPO_SOMA = "soma";
export const TIPO_MAXIMO = "maximo";
export const TIPO_SUBTRACAO = "subtracao";

// O cadastro grava "maximo"; as janelas antigas procuravam "maior". Os dois valem.
export function tipoDaEtapa(step) {
  const tipo = String(step?.calculation_type || TIPO_SOMA).trim().toLowerCase();
  if (tipo === "maximo" || tipo === "maior") return TIPO_MAXIMO;
  return tipo === TIPO_SUBTRACAO ? TIPO_SUBTRACAO : TIPO_SOMA;
}

// Quanto a etapa acrescenta (ou abate) no preço unitário do item. `precos` é o
// preço de cada opção marcada, repetido quando a opção tem quantidade.
//   Soma: soma tudo · Máximo: cobra só a mais cara · Subtração: abate tudo.
export function valorDaEtapa(step, precos) {
  const lista = (precos || []).map(Number).filter((n) => Number.isFinite(n));
  if (lista.length === 0) return 0;
  const tipo = tipoDaEtapa(step);
  if (tipo === TIPO_MAXIMO) return Math.max(...lista);
  const soma = lista.reduce((a, b) => a + b, 0);
  return tipo === TIPO_SUBTRACAO ? -soma : soma;
}

// Preço de cada linha de subitem, na ordem recebida. A soma das linhas é igual a
// `valorDaEtapa`: no Máximo só a opção mais cara leva valor (uma unidade); na
// Subtração a linha sai negativa. `opcoes` = [{ preco, qtd }].
export function linhasDaEtapa(step, opcoes) {
  const lista = (opcoes || []).map((o) => ({ preco: Number(o?.preco) || 0, qtd: Number(o?.qtd) || 1 }));
  const tipo = tipoDaEtapa(step);
  if (tipo === TIPO_SUBTRACAO) return lista.map((o) => -(o.preco * o.qtd));
  if (tipo === TIPO_MAXIMO) {
    const maior = Math.max(0, ...lista.map((o) => o.preco));
    const dona = lista.findIndex((o) => o.preco === maior);
    return lista.map((_, i) => (i === dona ? maior : 0));
  }
  return lista.map((o) => o.preco * o.qtd);
}

// Preço unitário de uma opção marcada, para mostrar na sacola/carrinho, no
// mesmo critério do popup do produto (getItemPrice do CardapioPublico) e de
// utils/etapasDoItem: etapa sincronizada (padrão) vale o preço do produto; sem
// sincronizar vale o price_override do cadastro, e 0 é GRÁTIS. Antes a sacola
// ignorava o override e mostrava "Banana R$ 3,50" num incluso grátis (achado 361).
// null = sem preço conhecido.
export function precoDaOpcao(step, stepItem, produto) {
  if (step?.sync_prices === false) {
    if (stepItem?.price_override === 0) return 0;
    if (stepItem?.price_override > 0) return Number(stepItem.price_override);
  }
  const preco = stepItem?.price ?? stepItem?.sale_price ?? produto?.sale_price ?? produto?.simple_price ?? null;
  return preco != null ? Number(preco) : null;
}

// Sinal do valor da opção na tela: "−" na Subtração, "+" nas outras.
export function sinalDaEtapa(step) {
  return tipoDaEtapa(step) === TIPO_SUBTRACAO ? "−" : "+";
}
